import React, { useEffect, useState } from 'react';
import { API, axios } from '../../utils/api';
import { euroMq, testoOmi, testoScostamento } from '../../utils/prezzoZona';

// Legge "€/m² di zona" (media dell'archivio entro 1 km e riferimento OMI) per un immobile. null finché non arriva.
export const usePrezzoZona = (immobileId, attivo = true) => {
  const [dati, setDati] = useState(null);
  useEffect(() => {
    if (!immobileId || !attivo) return undefined;
    let vivo = true;
    axios.get(`${API}/immobili/${immobileId}/prezzo-zona`).then((r) => { if (vivo) setDati(r.data); }).catch(() => { if (vivo) setDati({}); });
    return () => { vivo = false; };
  }, [immobileId, attivo]);
  return dati;
};

// Una riga per il parere dello staff: "3.890 €/m² · +59% sopra la media di zona (2.450 €/m², 8 case) · OMI …"
export const RigaScostamento = ({ zona }) => {
  if (!zona || (!zona.mq_immobile && !zona.omi)) return null;
  const pezzi = [
    zona.mq_immobile && euroMq(zona.mq_immobile),
    zona.scostamento_zona !== null && zona.scostamento_zona !== undefined
      && `${testoScostamento(zona.scostamento_zona)} (${euroMq(zona.zona.media)}, ${zona.zona.n} case)`,
    zona.omi && `${testoOmi(zona.omi)}${zona.scostamento_omi !== null && zona.scostamento_omi !== undefined ? `, ${testoScostamento(zona.scostamento_omi, 'il centro OMI')}` : ''}`,
  ].filter(Boolean);
  return <p className="text-xs text-muted-foreground" data-testid="scostamento">{pezzi.join(' · ')}</p>;
};
